var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30512 3.00507C9.57849 2.73171 10.0217 2.73171 10.2951 3.00507L13.7951 6.50507C14.0684 6.77844 14.0684 7.22166 13.7951 7.49502L10.2951 10.995C10.0217 11.2684 9.57849 11.2684 9.30512 10.995C9.03176 10.7217 9.03176 10.2784 9.30512 10.0051L12.3101 7.00005L9.30512 3.99502C9.03176 3.72166 9.03176 3.27844 9.30512 3.00507Z",
    fill: "#5B6885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60503 1.60503C1.7363 1.47375 1.91435 1.4 2.1 1.4H4.9C5.2866 1.4 5.6 1.0866 5.6 0.7C5.6 0.313401 5.2866 0 4.9 0H2.1C1.54305 0 1.0089 0.221249 0.615076 0.615076C0.221249 1.0089 0 1.54305 0 2.1V11.9C0 12.457 0.221249 12.9911 0.615076 13.3849C1.0089 13.7788 1.54304 14 2.1 14H4.9C5.2866 14 5.6 13.6866 5.6 13.3C5.6 12.9134 5.2866 12.6 4.9 12.6H2.1C1.91435 12.6 1.7363 12.5263 1.60503 12.395C1.47375 12.2637 1.4 12.0857 1.4 11.9V2.1C1.4 1.91435 1.47375 1.7363 1.60503 1.60503ZM4.9 6.3C4.5134 6.3 4.2 6.6134 4.2 7C4.2 7.3866 4.5134 7.7 4.9 7.7H13.3C13.6866 7.7 14 7.3866 14 7C14 6.6134 13.6866 6.3 13.3 6.3H4.9Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.2af082bc.svg";
export { ForwardRef as ReactComponent };